import { render, staticRenderFns } from "./PriceTarget.vue?vue&type=template&id=6778ca90&"
import script from "./PriceTarget.vue?vue&type=script&lang=ts&"
export * from "./PriceTarget.vue?vue&type=script&lang=ts&"
import style0 from "./PriceTarget.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports